import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
	computed: {
		isEnabled() {
			return this.$store.getters['features/isFeatureEnabled'](this.name);
		}
	}
})
export default class Feature extends Vue {
	@Prop()
	readonly name!: string;
}
